import axios from '../config/axios';
import { getApiUrl } from '../config/environment';

export type SendAppointmentConfirmationResult = {
  success: boolean;
  message?: string;
  error?: string;
  reminderId?: string;
};

export async function sendAppointmentConfirmation(
  appointmentId: string
): Promise<SendAppointmentConfirmationResult> {
  try {
    const res = await axios.post(
      getApiUrl(`/clinic/appointments/${appointmentId}/send-confirmation`)
    );
    return {
      success: !!res.data?.success,
      message: res.data?.message,
      reminderId: res.data?.reminderId,
      error: res.data?.error,
    };
  } catch (e: unknown) {
    const err = e as { response?: { data?: { error?: string; message?: string } }; message?: string };
    const apiError = err.response?.data?.error || err.response?.data?.message;
    if (apiError) {
      return { success: false, error: apiError };
    }
    return {
      success: false,
      error: err.message || 'Erro de rede ao enviar confirmação.',
    };
  }
}
